import styled from 'styled-components';

export const LatestUpdateSection = styled.div`
	display: flex;
	background-color: #f2f9f0;
	width: 100%;
	padding-left: 12px;
	align-items: center;
`;

export const LatestUpdateSectionPlaceholder = styled(LatestUpdateSection)`
	background-color: transparent;
`;

export const IconWrapper = styled.div`
	transform: translateY(2px);
	margin-right: 8px;
`;

export const MessageWrapper = styled.div`
	color: #1a1a1a;
	font-size: 13px;
	letter-spacing: 0.8px;
	line-height: 19px;
`;
